/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const card_with_padlock = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill="#000"
      d="M2 2.5v-.75.75Zm12 0v.75-.75ZM4 4.25a.75.75 0 1 0 0 1.5v-1.5Zm1.546 1.5a.75.75 0 0 0 0-1.5v1.5ZM4 8.25a.75.75 0 1 0 0 1.5v-1.5Zm3.115 1.5a.75.75 0 1 0 0-1.5v1.5Zm0 2.532a.75.75 0 0 0 0-1.5v1.5ZM14.25 4.5a.75.75 0 0 0 1.5 0h-1.5ZM9.5 9.364v-.75a.75.75 0 0 0-.75.75h.75Zm5.5 0h.75a.75.75 0 0 0-.75-.75v.75Zm0 4.136v.75a.75.75 0 0 0 .75-.75H15Zm-5.5 0h-.75c0 .414.336.75.75.75v-.75ZM2 3.25h12v-1.5H2v1.5Zm-.25 7.282V3.5H.25v7.032h1.5ZM4 5.75h1.546v-1.5H4v1.5Zm0 4h3.115v-1.5H4v1.5Zm3.115 1.032H2v1.5h5.115v-1.5ZM14.25 3.5v1h1.5v-1h-1.5Zm-14 7.032c0 .967.784 1.75 1.75 1.75v-1.5a.25.25 0 0 1-.25-.25H.25ZM14 3.25a.25.25 0 0 1 .25.25h1.5A1.75 1.75 0 0 0 14 1.75v1.5ZM2 1.75A1.75 1.75 0 0 0 .25 3.5h1.5A.25.25 0 0 1 2 3.25v-1.5Zm12.25 7.614V13.5h1.5V9.364h-1.5ZM15 12.75H9.5v1.5H15v-1.5Zm-4.75.75V9.364h-1.5V13.5h1.5Zm1.07-5.66c0-.46.392-.875.93-.875v-1.5c-1.318 0-2.43 1.04-2.43 2.375h1.5Zm.93-.875c.538 0 .93.415.93.875h1.5c0-1.335-1.112-2.375-2.43-2.375v1.5ZM9.5 10.114h1.07v-1.5H9.5v1.5Zm.32-2.274v1.524h1.5V7.84h-1.5Zm.75 2.274h3.36v-1.5h-3.36v1.5Zm3.36 0H15v-1.5h-1.07v1.5Zm-.75-2.274v1.524h1.5V7.84h-1.5Z"
    />
  </svg>
)
export default card_with_padlock
